import Environment from "services/environment/index";
import RestApiCall from "interceptor/aeh/index";

const env = Environment.getEnv();

export default class Service {
    static updateProfile({ payload, headers }) {
        let apiPayload = {
            method: "POST",
            url: "/user/v1/update/profile/attributes",
            baseURL: env.profileBaseUrl,
            data: payload,
            headers: { "rbac-identifier": headers.lob },
        }
        return RestApiCall.api(apiPayload);
    }

    static initiateCall({ payload, headers }) {
        let apiPayload = {
            method: "POST",
            url: "call/v1/initiate",
            baseURL: env.maintenanceBaseUrl,
            data: payload,
            config: { ignoreBusinessError: true },
            headers: { "rbac-identifier": headers.lob },
        }
        return RestApiCall.api(apiPayload);
    }

    static fetchCallDetails({ payload, headers }) {
        let apiPayload = {
            method: "POST",
            url: "call/v1/status",
            baseURL: env.maintenanceBaseUrl,
            data: payload,
            headers: { "rbac-identifier": headers.lob },
        }
        return RestApiCall.api(apiPayload);
    }
}